import type React from "react"

interface ButtonProps {
  children?: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  className?: string
}

export default function Button({ children = "Learn More", onClick, disabled = false, className = "" }: ButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center
        px-4 py-2
        text-sm font-medium
        text-gray-900
        bg-[#F3F4F6]
        rounded-xl
        shadow-sm
        hover:bg-gray-200
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-colors duration-200
        ${className}
      `}
    >
      {children}
    </button>
  )
}
